const topics = [
  { tag: '韩漫推荐', heat: '9.8', icon: 'ri-global-line', desc: '高人气连载中' },
  { tag: '日漫精选', heat: '9.7', icon: 'ri-sun-line', desc: '经典与新品' },
  { tag: '国漫崛起', heat: '9.6', icon: 'ri-flag-2-line', desc: '原创力作' },
  { tag: '玄幻修仙', heat: '9.5', icon: 'ri-magic-line', desc: '热血升级流' },
  { tag: '恋爱甜宠', heat: '9.4', icon: 'ri-heart-line', desc: '心动每一话' },
  { tag: '热血战斗', heat: '9.3', icon: 'ri-sword-line', desc: '燃到停不下来' },
  { tag: '悬疑推理', heat: '9.2', icon: 'ri-search-eye-line', desc: '烧脑反转' },
  { tag: '搞笑日常', heat: '9.1', icon: 'ri-emotion-laugh-line', desc: '欢乐解压' },
  { tag: '穿越重生', heat: '9.0', icon: 'ri-loop-left-line', desc: '逆袭人生' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">发现当下最受欢迎的漫画类型，总有一款适合你</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-3">
          {topics.map((item) => (
            <a
              key={item.tag}
              href="#index"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50/80 transition-colors cursor-pointer no-underline"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100/80 text-primary-600 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{item.tag}</span>
              <span className="text-xs font-bold text-accent-500">{item.heat}</span>
              <span className="text-xs text-foreground-500">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}